import { Pipe, PipeTransform } from '@angular/core';

import { IEnclosureSpecs } from '../../shared/models/enclosure.model';
import { EnclosureTypesNamesConstants } from '../constants/enclosure-types-names.constants';
import { IProductRange } from '../../shared/models/product.model';

@Pipe({
    name: 'enclosureImage',
    standalone: false
})
export class EnclosureImagePipe implements PipeTransform {

  transform(enclosureSpecs: IEnclosureSpecs[], enclosureRange: IProductRange, prismaXS: boolean, pragmaMultiCustomized: boolean): string {
    if (enclosureRange === null) {
      return EnclosureTypesNamesConstants.PRAGMA_MULTI_UP + '.png';
    }
    if(prismaXS) {
      return enclosureRange?.name.replace(/\s/g, '').replace('/', '') + '.png';
    }
    if(pragmaMultiCustomized) {
      return 'PragmaMultiCustomized.png';
    }

    const [ enclosureSpec ] = enclosureSpecs;

    return enclosureSpec?.image + '.png';
  }
}
